module.exports = __webpack_public_path__ + "static/008011-f351fb55f0929c97f2c6fdc4d7d246b6.jpg";